import React from 'react';
import { Skeleton } from '@material-ui/lab';
import './Category.css';

const Category = () => (
  <ul className="nav">
    {[...Array(5).keys()].map((ele) => 
      <Skeleton 
        key={ele}
        id="categorySkeleton"
        variant="text" 
        height={40} 
        width={110}
      />
    )}
  </ul>
);

export default Category




// WEBPACK FOOTER //
// ./src/components/Skeleton/Category.jsx